import React from 'react';
import './_index.scss';
import { reducerActions, FormattedMessageWrapper } from './utils';
import CapIcon from '../CapIcon';
import CapHeading from '../CapHeading';

const SubModuleSingleItem = ({
  itemSelected,
  displayLabel,
  name,
  disabled,
  showPremiumIcon,
  itemHovered,
  url,
  targetLocation,
  redirectionType,
  isDisabled = false,
  dispatchAction,
  handleRedirectionAndModuleSelection,
  l1_itemHovered,
  redirectToDifferentDomain = false,
  domainPattern = '',
  patternMapper = {},
  ...props
}) => (
  <CapHeading
    {...props}
    type="h6"
    className={`l2-item-submodule ${disabled || isDisabled ? 'nav-item-disabled' : ''} ${
      itemSelected ? 'itemSelected' : ''
    } ${!itemSelected && itemHovered && (!disabled && !isDisabled) ? 'itemHovered' : ''}`}
    // commenting because  memory consumption and controling hovered and disabled behaviour from css class
    // onMouseOver={() =>
    //   dispatchAction({
    //     type: reducerActions.hoveredL2Module,
    //     value: name,
    //   })
    // }
    // onMouseOut={() =>
    //   dispatchAction({
    //     type: reducerActions.hoveredL2Module,
    //     value: '',
    //   })
    // }
    onClick={(e) =>{
      e.stopPropagation()
      handleRedirectionAndModuleSelection({
        disabled : disabled||isDisabled,
        redirectionType,
        targetLocation,
        url,
        name,
        l1_itemHovered,
        redirectToDifferentDomain,
        domainPattern,
        patternMapper,
      })
    }
  }
  >
    <div>
      <FormattedMessageWrapper id={displayLabel} message={name} />
    </div>
    {showPremiumIcon ? (
      <CapIcon type="premiumColored" className="premium-icon" />
    ) : (
      ''
    )}
  </CapHeading>
);

export default SubModuleSingleItem;
